/**
 * Font loader utility to handle font loading
 */

const fontFamilies = [
  'metric',
  'metric-bold',
  'metric-medium',
  'metric-semibold',
  'metric-R',
  'metric-R-medium',
  'metric-R-semibold',
  'metric-R-bold',
  'metric-R-bolditalic',
  'source-sans-pro',
  'source-sans-pro-semi-bold',
  'Inter Variable',
];

/**
 * Loads all required fonts and resolves when they're all loaded
 * @returns Promise that resolves when all fonts are loaded
 */
export const loadFonts = async (): Promise<void> => {
  // Dynamically import FontFaceObserver
  const FontFaceObserver = (await import('fontfaceobserver')).default;

  // Create an observer for each font
  const fontPromises = fontFamilies.map((family) => {
    const font = new FontFaceObserver(family);
    // Set a timeout of 5 seconds for each font
    return font.load(null, 5000).catch((err) => {
      console.warn(`Font ${family} failed to load:`, err);
      // Don't fail the entire load if one font fails
      return Promise.resolve();
    });
  });

  // Wait for all fonts to load
  return Promise.all(fontPromises)
    .then(() => {
      // Add a class to the document to indicate fonts are loaded
      document.documentElement.classList.add('fonts-loaded');
      console.log('All fonts have been loaded');
    })
    .catch((err) => {
      console.error('Error loading fonts:', err);
      // Add class anyway so the app doesn't get stuck
      document.documentElement.classList.add('fonts-loaded');
    });
};
